import script from "./info-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./info-modal.vue?vue&type=script&setup=true&lang=js"

import "./info-modal.vue?vue&type=style&index=0&id=30c145e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30c145e4"]])

export default __exports__